<template>
  <modal-wrapper
    :open="showApp"
    @change="showApp = $event"
  >
    <div :class="$style.appVersionInfo">
      {{ version }}
    </div>
  </modal-wrapper>
</template>

<script setup lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onBeforeUnmount
} from 'vue';
import ModalWrapper from '@/shared/legacy/ui/modal-next/modal-wrapper.vue';
import { appConfig } from '@/shared/legacy/lib/config/app-config';

const showApp = ref(false);
const handleKeyDown = (event: KeyboardEvent) => {
  const isShowVersionShortcut
    = event.code === 'Backquote' && (event.ctrlKey || event.metaKey) && event.shiftKey;
  if (isShowVersionShortcut) {
    showApp.value = !showApp.value;
  }
};

onMounted(() => document.addEventListener('keydown', handleKeyDown));
onBeforeUnmount(() => document.removeEventListener('keydown', handleKeyDown));
const version = computed(() => appConfig.config.value?.version.split('-')[0]);

defineComponent({
  name: 'AppVersionInfo'
});
</script>

<style module>
.appVersionInfo {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 150px;
  color: #ffffff;
  background: rgba(56, 52, 63, 0.5);
}
</style>

<i18n lang="json">{}</i18n>
